// extracted by mini-css-extract-plugin
export default {"title":"_5489a2eb0f","inner_title":"_54bab920bf","charge_btn":"_44b90255d7"};